<app-page-header title="Support" description="Submit a support ticket to the PromoFlo team."></app-page-header>
<div class="support-container">
  <div class="quick-ticket">
    <h3>Quick Ticket Submission</h3>
    
    <div class="form-field">
      <label>Subject *</label>
      <dx-text-box 
        [(value)]="ticketForm.subject"
        placeholder="Brief description of your issue">
      </dx-text-box>
    </div>

    <div class="form-field">
      <label>Priority *</label>
      <dx-select-box 
        [(value)]="ticketForm.priority"
        [dataSource]="priorityOptions"
        displayExpr="text"
        valueExpr="value">
      </dx-select-box>
    </div>

    <div class="form-field">
      <label>Description *</label>
      <dx-text-area 
        [(value)]="ticketForm.description"
        placeholder="Please describe your issue in detail..."
        [height]="120">
      </dx-text-area>
    </div>

    <div class="form-actions">
      <dx-button 
        text="Submit Ticket" 
        type="success" 
        stylingMode="contained"
        (onClick)="submitTicket()"
        [disabled]="!isFormValid() || isSubmitting">
      </dx-button>
      <dx-button 
        text="Clear Form" 
        type="normal" 
        stylingMode="outlined"
        (onClick)="clearForm()"
        [disabled]="isSubmitting">
      </dx-button>
    </div>
  </div>

  <!-- User's Previous Tickets -->
  <div class="tickets-section">
    <h3>Your Support Tickets</h3>
    
    <dx-data-grid
      [dataSource]="filteredTickets"
      [showBorders]="true"
      [columnAutoWidth]="true"
      [allowColumnResizing]="true"
      [paging]="{ pageSize: 10 }"
      [loadPanel]="{ enabled: ticketsLoading, text: 'Loading tickets...' }"
      [noDataText]="'No support tickets found'"
      [headerFilter]="{ visible: true }"
      height="400">
      
      <dxo-toolbar>
        <dxi-item location="before">
          <dx-text-box 
            [(value)]="searchText"
            placeholder="Search tickets..."
            [showClearButton]="true"
            mode="search"
            width="250"
            (onValueChanged)="onSearchValueChanged($event)">
          </dx-text-box>
        </dxi-item>
        
        <dxi-item location="after">
          <dx-button 
            text="Refresh" 
            icon="refresh"
            type="normal"
            stylingMode="outlined"
            (onClick)="refreshTickets()"
            [disabled]="ticketsLoading">
          </dx-button>
        </dxi-item>
        
        <dxi-item location="after">
          <dx-check-box 
            [(value)]="showClosedTickets"
            text="Show Closed Tickets"
            (onValueChanged)="applyFilters()">
          </dx-check-box>
        </dxi-item>
      </dxo-toolbar>
      
      <dxi-column dataField="ticketNumber" caption="Ticket #" width="120" alignment="center">
      </dxi-column>
      
      <dxi-column dataField="subject" caption="Subject" minWidth="200">
      </dxi-column>
      
      <dxi-column dataField="status" caption="Status" width="120" alignment="center" [allowSorting]="true" cellTemplate="statusTemplate">
      </dxi-column>
      
      <dxi-column dataField="priority" caption="Priority" width="100" alignment="center" cellTemplate="priorityTemplate">
      </dxi-column>
      
      <dxi-column dataField="createdTime" caption="Created" width="150" dataType="datetime" format="dd/MM/yyyy HH:mm">
      </dxi-column>
      
      <dxi-column dataField="closedTime" caption="Closed" width="150" dataType="datetime" format="dd/MM/yyyy HH:mm">
      </dxi-column>
      
      <div *dxTemplate="let data of 'statusTemplate'">
        <span class="status-badge" [ngClass]="getStatusClass(data.value)">
          {{ data.value }}
        </span>
      </div>
      
      <div *dxTemplate="let data of 'priorityTemplate'">
        <span class="priority-badge" [ngClass]="getPriorityClass(data.value)">
          {{ data.value }}
        </span>
      </div>
      
    </dx-data-grid>
  </div>
</div>
